import React from "react";
import { ArrowUpRightIcon, InstagramIcon, YoutubeIcon, StarIcon, BoxIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { business, redes } from "../data/business";
const icones: Record<string, BoxIcon> = {
  instagram: InstagramIcon,
  youtube: YoutubeIcon,
  google: StarIcon
};
export function SocialSection() {
  return <section className="px-4 pt-12" aria-labelledby="titulo-redes" data-id="element-157" data-mp="346tu5vfzpe31">
      <SectionHeading id="titulo-redes" overline="Redes" titulo="Conteúdo e avaliações" descricao={`${business.avaliacao} de 5 no Google · ${business.totalAvaliacoes}`} data-id="element-158" data-mp="3j0ouue5zrx35" />

      <ul className="space-y-3" data-id="element-159" data-mp="3rutkiu9e32h3">
        {redes.map(rede => {
        const Icone = icones[rede.id] ?? ArrowUpRightIcon;
        return <li key={rede.id} data-id="element-160" data-mp="3ntzwm0vy5no7">
              <a href={rede.url} target="_blank" rel="noreferrer" className="group flex items-center gap-3.5 rounded-2xl border border-shell bg-white/60 px-4 py-3.5 transition-colors duration-150 ease-out hover:border-mocha/30 hover:bg-white active:bg-sand focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mocha" data-id="element-161" data-mp="3nv2itvibr1xs">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-mocha-soft" data-id="element-162" data-mp="atl8c36tdvfj">
                  <Icone className="h-[18px] w-[18px] text-mocha" strokeWidth={1.5} data-id="element-163" data-mp="fqlcg8k3so40" />
                </span>
                <span className="min-w-0 flex-1" data-id="element-164" data-mp="jrdmv54poz1v">
                  <span className="block text-[14px] font-medium text-ink" data-id="element-165" data-mp="otcr0h89zzzv">{rede.rede}</span>
                  <span className="block truncate text-[12.5px] text-muted" data-id="element-166" data-mp="tr4mfl84q48t">{rede.usuario}</span>
                </span>
                <ArrowUpRightIcon className="h-4 w-4 shrink-0 text-mocha" strokeWidth={1.6} data-id="element-167" data-mp="yjflymyyjo0u" />
              </a>
            </li>;
      })}
      </ul>
    </section>;
}